import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { images } from "./images";
import { V7EmilyShowerAfter } from "./V7";

export const V7EmilyShower = async (): Promise<any> => {
    let text = `I can hear the shower water running...`;
    if (Game.seenScenarios.includes(`V7EmilyPhone`)) {
        text = `Emily is still in the shower...`;

    }
    await mc.setQuestion(new Question({ text, options: { think: true }, key: `v7EmilyShowerPeaked` })
        .option({ title: `Go take a peak`, key: true })
        .option({ title: `Wait for her`, key: false }));


    if (Question.globalAnswers.v7EmilyShowerPeaked) {
        if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
            mc.think(`After seeing her washing the car I can't help but look...`);

        } else {

            mc.think(`I little peek wouldn't hurt...`);
        }
        ImageClass.setImage(images.v7.EmilyShower_1, { duration: 1.5, hideText: true, wait: 1.5 });
        mc.think(`Oh my... My ${emily.properties.relation} is so hot...`);
        ImageClass.setImage(images.v7.EmilyShower_3, { duration: 1.5 });
        mc.think(`The way the drops slide across her smooth body...`);
        mc.think(`She is so relaxed...she has no idea I'm watching her.`);

        ImageClass.setImage(images.v7.EmilyShower_5, { duration: 1.5 });
        if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {
            mc.think(`If only I could join.`);

        } else {

        }
        mc.think(`Such a perfect ass... And the well-shaped breasts...`);
        mc.think(`${mc.name}! What are you thinking? Snap out of it!!!`);
        mc.think(`Damn, I should leave.`);



    } else {
        if (Question.globalAnswers.v7EmilyCarWashThoughtEmilyIsHot) {

            mc.think(`I know she is hot and all... But she is my ${emily.properties.relation}!`);

        } else {

            mc.think(`I respect my ${emily.properties.relation}'s privacy.`);
        }


    }

    return jump(V7EmilyShowerAfter, "V7EmilyShowerAfter");
};